<rid-demo-page [title]="'<rid-egg-cartons>'" previousRoute="/component-lab">
  <rid-egg-cartons [eggs]="27" class="mx-auto" />
</rid-demo-page>
